import React from 'react';

import TopLayout from './components/TopLayout';
import theme from './theme';

// eslint-disable-next-line react/prop-types
export default function wrapRootElement({ element }) {
  return <TopLayout theme={theme}>{element}</TopLayout>;
}
